export function LogoMark({ size = 40, dark = false }) {
  const stroke = dark ? "#F5B700" : "#F5B700";
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" data-testid="logo-mark">
      <rect width="64" height="64" rx="10" fill={dark ? "#F5B700" : "#111111"} />
      <path d="M18 14v36M46 14v36M18 32h28" stroke={dark ? "#111111" : stroke} strokeWidth="7" strokeLinecap="square" />
      <circle cx="32" cy="32" r="5.5" fill={dark ? "#F5B700" : "#111111"} stroke={dark ? "#111111" : stroke} strokeWidth="3" />
    </svg>
  );
}

export function Logo({ dark = false, compact = false }) {
  return (
    <span className="flex items-center gap-3" data-testid="site-logo">
      <LogoMark size={compact ? 34 : 40} dark={dark} />
      {!compact && (
        <span className="leading-none">
          <span className={`block font-heading font-700 text-[15px] tracking-wide font-bold ${dark ? "text-white" : "text-[#111111]"}`}>
            HARI OM
          </span>
          <span className={`block font-heading text-[11px] font-semibold tracking-[0.22em] ${dark ? "text-[#F5B700]" : "text-[#667085]"}`}>
            TRADING CO.
          </span>
        </span>
      )}
    </span>
  );
}
